<script setup>
import { onMounted, ref, reactive, computed, watch } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Head, Link, usePage } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import PageHeader from "@/Components/PageHeader.vue";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import {
    mdiEye, mdiCog, mdiArrowUpCircle, mdiArrowDownCircle, mdiArrowDownBold, mdiClipboardEdit, mdiCashPlus, mdiPlusCircle, mdiInformationOutline
} from "@mdi/js";
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import CardBoxComponentLoad from '@/Components/CardBoxComponentLoad.vue';
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import CardBoxWidget from "@/Components/CardBoxWidget.vue";
import SectionTitleLineWithButton from "@/Components/SectionTitleLineWithButton.vue";
//import SectionTitleLineWithButtonUnens from "@/Components/SectionTitleLineWithButtonUnens.vue";// <-- Cambios para agregar más contenido
import LineChart from "@/Components/Charts/LineChart.vue";
import BarChart from "@/Components/Charts/BarChart.vue";
import NotificationAlert from "@/Components/NotificationAlert.vue";
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
//import RadarChart from "@/Components/Charts/RadarChart.vue";// Example <-- cambiar a sólo RadarChart y no Example
// Pruebas
//import * as chartConfig from "@/Components/Charts/chart.config.js";

// Formulario
import BreezeLabel from '@/Components/Label.vue';
import BreezeInput from '@/Components/Input.vue';

// Section Configuration
import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Inertia } from '@inertiajs/inertia';
import VueSelect from "vue3-select-component";
import Buttons from "@/Components/Buttons.vue";

const props = defineProps({
    actioncontrol: {
        type: String,
        default: 'view'
    },
    titleup: String,
    events: Array,
    isAdmin: Boolean,
    isAdminCoord: Boolean,
    isSecre: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    orderPtePagos: Number,
    orderPtePagosRet: Number,
    orderFacturado: Number,
    orderNoFacturado: Number,
    confConst: Object,
    message: String,
    products: Object
});

const pinSecurity = ref('')
const action = ref(props.actioncontrol) // Los props son de lectura así que en el template se haré cambios al action segúnn el click a cada boton
const tab = ref(0)

if (action.value == 'view_estados_cuenta') {
    tab.value = 1
}

//console.log(props.listStudentsPtePagosRet)
const msg1 = ref('')
const navigatorVersion = ref('')
const navigatorName = ref('')
onMounted(() => {
    navigatorVersion.value = navigator.appVersion
    navigatorName.value = navigator.appName
});


const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
const messageLastAction = ref('')
const messageError = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message = '', type, time = 1) => {

    messageAlert.value = message
    colorAlert.value = type// <-- Tipo define el color
    isAlertActive.value = true

    // grabar última acción
    messageLastAction.value = message

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        //messageAlert.value = '' <-- Comentar para que no halla error de prop indefined en el componente NotificationAlert
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

/**
 * Section configuration
 * 
 */
console.log(props.confConst)
const tarifaForm = reactive({
    //matriculaGeneral: props.confConst ? props.confConst.matriculaGeneral : 0,
    matriculaInicial: props.confConst ? props.confConst.matriculaInicial : 0,
    matriculaPrimaria: props.confConst ? props.confConst.matriculaPrimaria : 0,
    matriculaSecundaria: props.confConst ? props.confConst.matriculaSecundaria : 0,
    pensionInicial: props.confConst ? props.confConst.pensionInicial : 0,
    pensionPrimaria: props.confConst ? props.confConst.pensionPrimaria : 0,
    pensionSecundaria: props.confConst ? props.confConst.pensionSecundaria : 0,
});

const tarifaSubmit = () => {
    // - LRR mainStore.setUser(profileForm);
    //setUser(profileForm);
    let ruta = 'constante-actualizar-configurations'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'typeConfiguration': 'tarifa',
        //'matriculaGeneral' : tarifaForm.matriculaGeneral,
        'matriculaInicial': tarifaForm.matriculaInicial,
        'matriculaPrimaria': tarifaForm.matriculaPrimaria,
        'matriculaSecundaria': tarifaForm.matriculaSecundaria,
        'pensionInicial': tarifaForm.pensionInicial,
        'pensionPrimaria': tarifaForm.pensionPrimaria,
        'pensionSecundaria': tarifaForm.pensionSecundaria,
    }
    ))
};

const otherConfForm = reactive({
    automatizarAcceso: props.confConst ? props.confConst.automatizarAcceso : 0,
    diaValidarAccesoPago: props.confConst ? props.confConst.diaValidarAccesoPago : 1,
    fechaBloqueo: props.confConst ? props.confConst.fechaBloqueo : '',
    crearOrdenPagoEstudiante: props.confConst ? props.confConst.crearOrdenPagoEstudiante : 0,
    colaboradorPenalidadDescuentoMinuto: props.confConst ? props.confConst.colaboradorPenalidadDescuentoMinuto : '',
    pensionmoraxdia: props.confConst ? props.confConst.pensionmoraxdia : '',
    cobranzamensaje: props.confConst ? props.confConst.cobranzamensaje : '',
});

const otherConfSubmit = () => {
    //
    let ruta = 'constante-actualizar-configurations'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'typeConfiguration': 'finanOtherConf',
        'automatizarAcceso': otherConfForm.automatizarAcceso,
        'diaValidarAccesoPago': otherConfForm.diaValidarAccesoPago,
        'fechaBloqueo': otherConfForm.fechaBloqueo,
        'crearOrdenPagoEstudiante': otherConfForm.crearOrdenPagoEstudiante,
        'colaboradorPenalidadDescuentoMinuto': otherConfForm.colaboradorPenalidadDescuentoMinuto,
        'pensionmoraxdia': otherConfForm.pensionmoraxdia,
        'cobranzamensaje': otherConfForm.cobranzamensaje,
    }
    ))
};


const reloadProps = (contentArray = []) => {
    Inertia.reload({ only: contentArray })
}

const formatDate = (date, type = '') => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    if (type == 'ISO') {
        result = date.getFullYear() + '-' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate()
    }
    return result
}

// Ejecutar
const ejecutarConfirm = ref([])
const crearStory = (type = 1) => {

    let ruta = 'student-store-story'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'anio': props.anioEscolar,
        'type': type

    }
    ))

}

const ejecutar = (type = '') => {

    let ruta = 'student-ejecutar'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'type': type

    }
    ))

}

const showAyuda = ref([
    { 'ordenpago': false },
    { 'configuracion': false },
    { 'cobranzas': false },
    { 'facture': false }
])

/**
 * Procesar archivos adjuntos
 */
const arrayDocumentos = ref([]);
const arrayDocumentosCol = ref([]);
const listarDocumentos = (subtype = '') => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/document/file_ecommerce' + subtype;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayDocumentos.value = respuesta.datalist;
        arrayDocumentosCol.value = respuesta.columnas;
        console.log(arrayDocumentos.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const inputFileName = ref('')
const inputFileDesc = ref('')
const inputSrcId = ref(0)
const inputFilePos = ref(1)
const showInputFile = ref(false)
const fileDocument = ref(null)
const fileSize = ref(0)
const errorMessage = ref('')
const changeFile = (type) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    let file = null;
    if (type == 'file_ecommerce_slides' || type == 'file_ecommerce_promos' || type == 'file_ecommerce_docs'  || type == 'file_ecommerce_certs') {
        file = fileDocument.value.files[0];
    }

    //console.log(file);
    console.log(file.size);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (file) {
        fileSize.value = file.size
        if (file.name.includes('.jpg') || file.name.includes('.png')) {
            console.log('Es imagen')
        } else {
            console.log('No es imagen jpg o png')
        }
    }

}

const uploadFile = (type, origin_id = 0) => {
    let data = new FormData()
    let file = null;
    if (type == 'file_ecommerce_slides' || type == 'file_ecommerce_promos' || type == 'file_ecommerce_docs'  || type == 'file_ecommerce_certs') {
        file = fileDocument.value.files[0];
        origin_id = inputSrcId.value
    }
    data.append('file', file)
    data.append('origin_type', type)

    // Se puede agregar otro origin id si fuera necesario
    data.append('origin_id', origin_id)

    data.append('name', inputFileName.value)
    data.append('description', inputFileDesc.value)
    data.append('position', inputFilePos.value)
    console.log(file)
    axios.post('/file/upload', data)
        .then(response => {

            if (response.data.error) {
                showAlert(response.data.message, 'danger', 5)
                if (type == 'file_ecommerce_slides' || type == 'file_ecommerce_promos' || type == 'file_ecommerce_docs'  || type == 'file_ecommerce_certs') {
                    errorMessage.value == response.data.message
                }
            } else if (response.data.success) {
                showAlert(response.data.message, 'success', 2)
                if (type == 'file_ecommerce_slides') {
                    listarDocumentos('_slides')
                } else if (type == 'file_ecommerce_promos') {
                    listarDocumentos('_promos')
                } else if (type == 'file_ecommerce_docs') {
                    listarDocumentos('_docs')
                } else if (type == 'file_ecommerce_certs') {
                    listarDocumentos('_certs')
                }
                cleanInputFile()

            }
            console.log(response.data)
        })
        .catch(error => {
            console.log(error)
        })

}

const cleanInputFile = () => {
    inputFileName.value = ''
    inputFileDesc.value = ''
    inputFilePos.value = 1
    fileDocument.value = null
    fileSize.value = 0
    inputSrcId = 0
}

const confGlobalLocal = computed(() => usePage().props.value.confGlobal);

const tabOptions = computed(() => {
    let options = [
        { id: 0, label: 'Configuración', icon: 'tabler:settings' },
        { id: 1, label: 'Slides', icon: 'tabler:photo' },
    ];
    
    if (confGlobalLocal.value && confGlobalLocal.value.ECOMMERCE_ENABLE_PROMOCIONES == 1) {
        options.push({ id: 2, label: 'Promociones', icon: 'tabler:discount' });
    }
    options.push({ id: 4, label: 'Certificados', icon: 'tabler:certificate' });
    options.push({ id: 3, label: 'Otros Documentos', icon: 'tabler:file-text' });
    
    return options;
});

watch(tab, (newVal) => {
    if (newVal === 1) listarDocumentos('_slides');
    else if (newVal === 2) listarDocumentos('_promos');
    else if (newVal === 4) listarDocumentos('_certs');
    else if (newVal === 3) listarDocumentos('_docs');
});
</script>

<template>
    <Head title="Configuración" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Configuración Ecommerce" subtitle="Gestión de configuración y documentos" :forceActionsOnTop="true"  :tabs="tabOptions" :back-route="null" :show-back="false" v-model="tab"  :wrapTabsOnMobile="true">
                <template #actions>
                    <Buttons :href="route('dashboard')" color="primary" size="header" icon="mdi:arrow-u-left-top-bold" label="Volver al Inicio" :hideLabelOnMobile="true" />
                </template>
            </PageHeader>
        </template>


        <!-- <CardBoxModal v-model="showDialog" :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')"
            hasCancel>
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} :
                {{ selectedEvent.start && selectedEvent.start.formatTime() }} -
                {{ selectedEvent.end && selectedEvent.end.formatTime() }}
            </strong>
            <p v-html="selectedEvent.contentFull" />
        </CardBoxModal> -->

        <div class="py-8 lg:py-10">
            <!-- Configuración -->
            <template v-if="tab == 0">
                <div class="sm:px-6 lg:px-8 px-4 mx-auto pb-4"><!--max-w-7xl-->
                    <div class="grid grid-cols-4 gap-4 bg-white rounded-md overflow-hidden shadow-lg border">
                        <div class="col-span-4 p-4">
                            <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->
                            <ul>
                                <li>
                                    <Link class="hover:text-rose-600" :href="route('constante-edit')">Opciones avanzadas</Link>
                                </li>
                            </ul>
                            <!-- <div>
                                <div class="mb-2">
                                    <ul>
                                        <li>Se muestran las tarifas de matrícula y pensión por defecto.</li>
                                        <li>Debe establecer los montos actuales antes de inicializar órdenes de pago para que estas se creen con la tarifa actual.</li>
                                        <li>Si hay dos empresas debe asignar el nivel educativo con la entidad que corresponde en panel de configuración, niveles (sólo se toma en cuenta el nivel padre)</li>
                                        <li v-if="pinSecurity != confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY">Para realizar cambios ingrese el Pin de seguridad (no se verá lo que escribe) <input id="pin_security" name="pin_security" type="text" class="text-transparent border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="pinSecurity" autocomplete="off" title="Si selecciona el campo podrá ver lo que escribió"></li>
                                    </ul>
                                </div>
                                <div>
                                    <BreezeValidationErrors class="mb-4" />
                                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                        <CardBox is-form @submit.prevent="tarifaSubmit">
                                
                                            <FormField label="Matrícula inicial" help="">
                                                <FormControl
                                                v-model="tarifaForm.matriculaInicial"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="matriculaInicial"
                                                required
                                                autocomplete="matriculaInicial"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            <FormField label="Matrícula primaria" help="">
                                                <FormControl
                                                v-model="tarifaForm.matriculaPrimaria"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="matriculaPrimaria"
                                                required
                                                autocomplete="matriculaPrimaria"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            <FormField label="Matrícula secundaria" help="">
                                                <FormControl
                                                v-model="tarifaForm.matriculaSecundaria"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="matriculaSecundaria"
                                                required
                                                autocomplete="matriculaSecundaria"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Pensión Inicial" help="">
                                                <FormControl
                                                v-model="tarifaForm.pensionInicial"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="pensionInicial"
                                                required
                                                autocomplete="pensionInicial"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            <FormField label="Pensión Primaria" help="">
                                                <FormControl
                                                v-model="tarifaForm.pensionPrimaria"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="pensionPrimaria"
                                                required
                                                autocomplete="pensionPrimaria"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            <FormField label="Pensión Secundaria" help="">
                                                <FormControl
                                                v-model="tarifaForm.pensionSecundaria"
                                                :icon="mdiCashPlus"
                                                type="number"
                                                name="pensionSecundaria"
                                                required
                                                autocomplete="pensionSecundaria"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <template #footer>
                                                <BaseButtons>
                                                    <BaseButton v-if="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? true : false)" color="info" type="submit" label="Guardar" />
                                                    
                                                </BaseButtons>
                                            </template>
                                        </CardBox>

                                        <CardBox is-form @submit.prevent="otherConfSubmit">


                                            <FormField label="Automatizar Acceso" help="Actualizar acceso del alumno desde txt de pagos">
                                                <FormControl
                                                v-model="otherConfForm.automatizarAcceso"
                                                :icon="mdiCog"
                                                name="automatizarAcceso"
                                                type="yesno"
                                                required
                                                autocomplete="automatizarAcceso"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Día límite para desactivar accesos" help="Luego de este día, al subir los txt de pagos se desactivarán los usuarios">
                                                <FormControl
                                                v-model="otherConfForm.diaValidarAccesoPago"
                                                :icon="mdiCog"
                                                name="diaValidarAccesoPago"
                                                type="number"
                                                required
                                                autocomplete="diaValidarAccesoPago"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Fecha de Bloqueo" help="Fecha de bloqueo recaudo banco en txt de altas o bajas, sin espacios o carácteres especiales (ejem. 20301231)">
                                                <FormControl
                                                v-model="otherConfForm.fechaBloqueo"
                                                :icon="mdiCog"
                                                name="fechaBloqueo"
                                                type="text"
                                                required
                                                autocomplete="fechaBloqueo"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Crear orden de pago al crear estudiante" help="Al crear un estudiante mostrar la opción de crear sus órdenes de pago (matrícula, pensión)">
                                                <FormControl
                                                v-model="otherConfForm.crearOrdenPagoEstudiante"
                                                :icon="mdiCog"
                                                name="crearOrdenPagoEstudiante"
                                                type="yesno"
                                                required
                                                autocomplete="crearOrdenPagoEstudiante"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>
                                            
                                            <FormField label="Colaborador, penalidad descuento por minuto" help="Asistencia, penalidad descuento por minuto (tardanza y salida temprano)">
                                                <FormControl
                                                v-model="otherConfForm.colaboradorPenalidadDescuentoMinuto"
                                                :icon="mdiCog"
                                                name="colaboradorPenalidadDescuentoMinuto"
                                                type="text"
                                                required
                                                autocomplete="colaboradorPenalidadDescuentoMinuto"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField v-if="confGlobal.value.FINANCIERA_USE_MORA == 1" label="Pensión, mora por día de atraso" help="Cobranzas, se sumará el monto desde la fecha de vencimiento hasta la actual.">
                                                <FormControl
                                                v-model="otherConfForm.pensionmoraxdia"
                                                :icon="mdiCog"
                                                name="pensionmoraxdia"
                                                type="text"
                                                required
                                                autocomplete="pensionmoraxdia"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <FormField label="Mensaje por defecto de cobranza" help="Cobranzas, se puede usar las palabras reservadas: __APODERADO_NOMBRE__, __REF_DEUDAS__, __TOT_PENSION__, __TOT_MORA__, __TOT_OTROS__, __TOT_ACTUAL__">
                                                <FormControl
                                                v-model="otherConfForm.cobranzamensaje"
                                                :icon="mdiCog"
                                                name="cobranzamensaje"
                                                type="textarea"
                                                required
                                                autocomplete="cobranzamensaje"
                                                :readonly="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)"
                                                />
                                            </FormField>

                                            <template #footer>
                                                <BaseButtons>
                                                    <BaseButton v-if="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? true : false)" type="submit" color="info" label="Guardar" />
                                                   
                                                </BaseButtons>
                                            </template>
                                        </CardBox>
                                    </div>
                                </div>
                            </div> -->

                        </div>
                    </div>
                </div>
            </template>
            <!-- Documentos Slides -->
            <template v-else-if="(tab == 1)">
                <div class="sm:px-6 lg:px-8 px-4 mx-auto pb-4"><!--max-w-7xl-->
                    <div class="grid grid-cols-1 gap-4 bg-white rounded-md overflow-hidden shadow-lg border">
                        <div class="col-span-1 p-4 pb-0">
                            <h2 class="mb-3">Slides, se recomeinda agregar hasta 3 slides</h2>
                            <!-- <div v-if="message">{{ message }}</div> -->
                            <div v-if="canWrite" class="">
                                <p class="my-2 text-sm mb-3">
                                    Se recomienda subir archivos png, con un <b>límite máximo</b> de {{ confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE }}
                                    KB. <b>Si ingresa un nombre que ya existe el archivo anterior será reemplazado por este</b>.
                                </p>

                                <ul>
                                    <li>En el diseño debe considerar que es reponsive. Se recomienda la dimensión de 1920 x 765</li>
                                    <li>El nombre de archivo aparecerá en el slide y una breve descripción, puede relacionar a un producto si fuera necesario</li>
                                </ul>
                                <div v-if="fileSize > (1000 * parseInt(confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE))" class="mb-4">
                                    <small class="font-medium text-red-600">El archivo
                                        supera
                                        el tamaño límite permitido</small>
                                </div>
                                <div class="mb-4 w-full">
                                    <label for="name" class="text-sm mb-1">Nombre de Archivo (sin extensión) </label>
                                    <BreezeInput id="inputname" type="text" class="mt-1 block w-full" v-model="inputFileName" required />
                                </div>
                                <div class="mb-4">
                                    <label for="desc" class="text-sm mb-1">Descripción (opcional) </label>
                                    <textarea id="inputdesc" type="text" class="mt-1 block w-full" v-model="inputFileDesc" autocomplete="off"> </textarea>
                                </div>
                                <div class="mb-4">
                                    <label for="desc" class="text-sm mb-1">Relacionar a un producto (opcional) </label>
                                    <VueSelect v-if="products.length" class="select-search-light" v-model="inputSrcId" :options="products" placeholder="Productos activos" />
                                </div>
                                <!-- <div>
                            <BreezeLabel for="pos" value="Posición" />
                            <BreezeInput id="inputpos" type="number"
                                class="mt-1 block" v-model="inputFilePos" />
                            </div> -->
                                <div class="mb-4">
                                    <label>
                                        <input id="file_ecommerce_slides" ref="fileDocument" type="file" @change="changeFile('file_ecommerce_slides')" class="w-full" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">
                                    </label>
                                </div>
                                <!-- <label>
                                <input type="file" id="fileCatalogo" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="w-full input-file input-file-slate" />
                            </label> -->

                                <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Guardar" @click="uploadFile('file_ecommerce_slides')" class="btn btn-blue px-8 lg:w-auto w-full" />
                            </div>
                            <hr class="my-4">
                            <!-- Lista -->
                            <div class="w-full overflow-x-auto relative">
                                <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                                    <!-- Tablesingle opciones: checkable -->
                                    <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file" :deleteable="canDelete ? true : false" originType="file_ecommerce_slides" @reload="listarDocumentos('_slides')" />
                                </CardBox>
                                <CardBox v-else>
                                    <CardBoxComponentEmpty />
                                </CardBox>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <!-- Promociones -->
            <template v-else-if="(tab == 2)">
                <div class="sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                    <div class="grid grid-cols-1 gap-4 bg-white rounded-md overflow-hidden shadow-lg border">
                        <div class="col-span-1 p-4 pb-0">
                            <h2 class="mb-3">Promociones, se muestran en la parte inferior al inicio de la página las últimas 2 promociones.</h2>
                            <!-- <div v-if="message">{{ message }}</div> -->
                            <div v-if="canWrite" class="">
                                <p class="my-2 text-sm mb-3">
                                    Se sugiere la dimensión 720 x 300,
                                    PNG, con un <b>límite máximo</b> de {{
                                        confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE }}
                                    KB. <b>Si ingresa un nombre que ya existe el documento anterior será reemplazado por este</b>.
                                </p>
                                <div v-if="fileSize > (1000 * parseInt(confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE))" class="mb-4">
                                    <small class="font-medium text-red-600">El archivo
                                        supera
                                        el tamaño límite permitido</small>
                                </div>
                                <div class="mb-4 w-full">
                                    <label for="name" class="text-sm mb-1">Nombre de Archivo </label>
                                    <BreezeInput id="inputname" type="text" class="mt-1 block w-full" v-model="inputFileName" required />
                                </div>
                                <div class="mb-4">
                                    <label for="desc" class="text-sm mb-1">Descripción (opcional) </label>
                                    <textarea id="inputdesc" type="text" class="mt-1 block w-full" v-model="inputFileDesc" autocomplete="off"> </textarea>
                                </div>
                                <div class="mb-4">
                                    <label for="desc" class="text-sm mb-1">Relacionar a un producto</label>
                                    <VueSelect v-if="products.length" class="w-full select-search-light" v-model="inputSrcId" :options="products" placeholder="Productos activos"/>
                                </div>
                                <!-- <div>
                            <BreezeLabel for="pos" value="Posición" />
                            <BreezeInput id="inputpos" type="number"
                                class="mt-1 block" v-model="inputFilePos" />
                            </div> -->
                                <div class="mb-4">
                                    <label>
                                        <input id="file_ecommerce_promos" ref="fileDocument" type="file" @change="changeFile('file_ecommerce_promos')" class="w-full" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">
                                    </label>
                                </div>
                                <!-- <label>
                                <input type="file" id="fileCatalogo" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="w-full input-file input-file-slate" />
                            </label> -->

                                <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Guardar" @click="uploadFile('file_ecommerce_promos')" class="btn btn-blue px-8 lg:w-auto w-full" />
                            </div>
                            <hr class="my-4">
                            <!-- Lista -->
                            <div class="w-full overflow-x-auto relative">
                                <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                                    <!-- Tablesingle opciones: checkable -->
                                    <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file" :deleteable="canDelete ? true : false" originType="file_ecommerce_promos" @reload="listarDocumentos('_promos')" />
                                </CardBox>
                                <CardBox v-else>
                                    <CardBoxComponentEmpty />
                                </CardBox>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="(tab == 3)">
                <div class="sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                    <div class="grid grid-cols-1 gap-4 bg-white rounded-md overflow-hidden shadow-lg border">
                        <div class="col-span-1 p-4 pb-0">
                            <h2 class="mb-3">Logos y otras imágenes, se deben respetar los formatos</h2>
                            <!-- <div v-if="message">{{ message }}</div> -->
                            <div v-if="canWrite" class="">
                                <p class="my-2 text-sm mb-3">
                                    Se recomienda subir archivos png o jpg, con un <b>límite máximo</b> de {{ confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE }}
                                    KB. <b>Si ingresa un nombre que ya existe el archivo anterior será reemplazado por este</b>.
                                </p>
                                Los archivos por defecto son los siguientes:
                                <ul>
                                    <li>img_services.jpg (imagen de servicios en página principal) </li>
                                </ul>
                                <div v-if="fileSize > (1000 * parseInt(confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE))" class="mb-4">
                                    <small class="font-medium text-red-600">El archivo
                                        supera
                                        el tamaño límite permitido</small>
                                </div>
                                <div class="mb-4 w-full">
                                    <label for="name" class="text-sm mb-1">Nombre de Archivo </label>
                                    <BreezeInput id="inputname" type="text" class="mt-1 block w-full" v-model="inputFileName" required />
                                </div>
                                <div class="mb-4">
                                    <label for="desc" class="text-sm mb-1">Descripción (opcional) </label>
                                    <textarea id="inputdesc" type="text" class="mt-1 block w-full" v-model="inputFileDesc" autocomplete="off"> </textarea>
                                </div>
                                <!-- <div>
                            <BreezeLabel for="pos" value="Posición" />
                            <BreezeInput id="inputpos" type="number"
                                class="mt-1 block" v-model="inputFilePos" />
                            </div> -->
                                <div class="mb-4">
                                    <label>
                                        <input id="file_ecommerce_docs" ref="fileDocument" type="file" @change="changeFile('file_ecommerce_docs')" class="w-full" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">
                                    </label>
                                </div>
                                <!-- <label>
                                <input type="file" id="fileCatalogo" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="w-full input-file input-file-slate" />
                            </label> -->

                                <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Guardar" @click="uploadFile('file_ecommerce_docs')" class="btn btn-blue px-8 lg:w-auto w-full" />
                            </div>
                            <hr class="my-4">
                            <!-- Lista -->
                            <div class="w-full overflow-x-auto relative">
                                <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                                    <!-- Tablesingle opciones: checkable -->
                                    <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file" :deleteable="canDelete ? true : false" originType="file_ecommerce_docs" @reload="listarDocumentos('_docs')" />
                                </CardBox>
                                <CardBox v-else>
                                    <CardBoxComponentEmpty />
                                </CardBox>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="(tab == 4)">
                <div class="sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                    <div class="grid grid-cols-1 gap-4 bg-white rounded-md overflow-hidden shadow-lg border">
                        <div class="col-span-1 p-4 pb-0">
                            <h2 class="mb-3">Carga de imágenes para el área de certificados</h2>
                            <!-- <div v-if="message">{{ message }}</div> -->
                            <div v-if="canWrite" class="">
                                <p class="my-2 text-sm mb-3">
                                    Se recomienda subir archivos png sin bordes, con un <b>límite máximo</b> de {{ confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE }}
                                    KB. <b>Si ingresa un nombre que ya existe el archivo anterior será reemplazado por este</b>.
                                </p>
                            
                                <div v-if="fileSize > (1000 * parseInt(confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE))" class="mb-4">
                                    <small class="font-medium text-red-600">El archivo
                                        supera
                                        el tamaño límite permitido</small>
                                </div>
                                <div class="mb-4 w-full">
                                    <label for="name" class="text-sm mb-1">Nombre de Archivo </label>
                                    <BreezeInput id="inputname" type="text" class="mt-1 block w-full" v-model="inputFileName" required />
                                </div>
                                <div class="mb-4">
                                    <label for="desc" class="text-sm mb-1">Descripción (opcional) </label>
                                    <textarea id="inputdesc" type="text" class="mt-1 block w-full" v-model="inputFileDesc" autocomplete="off"> </textarea>
                                </div>
                                <!-- <div>
                            <BreezeLabel for="pos" value="Posición" />
                            <BreezeInput id="inputpos" type="number"
                                class="mt-1 block" v-model="inputFilePos" />
                            </div> -->
                                <div class="mb-4">
                                    <label>
                                        <input id="file_ecommerce_certs" ref="fileDocument" type="file" @change="changeFile('file_ecommerce_certs')" class="w-full" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">
                                    </label>
                                </div>
                                <!-- <label>
                                <input type="file" id="fileCatalogo" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="w-full input-file input-file-slate" />
                            </label> -->

                                <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Guardar" @click="uploadFile('file_ecommerce_certs')" class="btn btn-blue px-8 lg:w-auto w-full" />
                            </div>
                            <hr class="my-4">
                            <!-- Lista -->
                            <div class="w-full overflow-x-auto relative">
                                <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                                    <!-- Tablesingle opciones: checkable -->
                                    <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file" :deleteable="canDelete ? true : false" originType="file_ecommerce_certs" @reload="listarDocumentos('_certs')" />
                                </CardBox>
                                <CardBox v-else>
                                    <CardBoxComponentEmpty />
                                </CardBox>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <!-- <template v-else-if="tab==4">
                <div class="mx-auto sm:px-6 lg:px-8 px-4 pt-12">
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-md">
                        <div class="p-6 bg-white border-b border-gray-200">
                            
                            <div>
                                <Link :href="route('file-create', {'origin_type': 'file_resourceforcourse'})">
                                    <BaseButton
                                        color="info"
                                        :icon="mdiPlusCircle"
                                        small
                                        label=" Nuevo"
                                        class="float-right"
                                    />
                                </Link>
                            </div>
                            
                            <CardBox v-if="arrayFileResources.length" class="mb-6" has-table>
                               
                                <div class="w-full overflow-x-auto relative">
                                    <TableAdvanced modulo="Documento" modulos="Recursos de estudio" :data="arrayFileResources" :fields="arrayFileResourcesCol" ruta="file"
                                        updateable/>
                                </div>
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentLoad />
                            </CardBox>
                        </div>
                    </div>
                </div>
            </template> -->
        </div>
    </BreezeAuthenticatedLayout>
</template>
<style lang="css" scoped>
/* :deep(.vue-select .custom-value) {
    display: flex;
    align-items: center;
    gap: 6px;
    }

    :deep(.vue-select .custom-option) {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #171717;
    font-weight: 500;
    font-size: 16px;
    }

    :deep(.vue-select .custom-option small) {
    color: #525252;
    font-weight: 500;
    font-size: 14px;
    } */
</style>
